export default __webpack_public_path__ + "static/media/feature-network-2.931c2dde.png";